import { h } from "preact";

const rank_dpe0 = (nb) => {

    if (nb < 70) return "A";
    if (nb < 110) return "B";
    if (nb < 180) return "C";
    if (nb < 250) return "D";
    if (nb < 330) return "E";
    if (nb < 420) return "F";
    return "G";
}
const rank_ges0 = (nb) => {

    if (nb < 6) return "A";
    if (nb < 11) return "B";
    if (nb < 30) return "C";
    if (nb < 50) return "D";
    if (nb < 70) return "E";
    if (nb < 100) return "F";
    return "G";
}

const rank0 = (dpe, ges) => {

    const rank_dpe = rank_dpe0(dpe);
    const rank_ges = rank_ges0(ges);
    return rank_dpe > rank_ges ? rank_dpe : rank_ges

}

import GesA from "./GesA";
import GesB from "./GesB";
import GesC from "./GesC";
import GesD from "./GesD";
import GesE from "./GesE";
import GesF from "./GesF";
import GesG from "./GesG";

export default function Ges({ dpe, ges }) {

    // const rank = rank0(dpe, ges);
    const rank = rank_ges0(ges);

    if (rank == "A") return <GesA nb={ges} />;
    if (rank == "B") return <GesB nb={ges} />;
    if (rank == "C") return <GesC nb={ges} />;
    if (rank == "D") return <GesD nb={ges} />;
    if (rank == "E") return <GesE nb={ges} />;
    if (rank == "F") return <GesF nb={ges} />;
    if (rank == "G") return <GesG nb={ges} />;

}
